export enum TimelineItemStatus {
  Active = 'active',
  Checked = 'checked',
  Unchecked = 'unchecked',
}
